import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ToastBaseComponent, ToastData } from '../toast.type';

@Component({
  selector: 'red-warning-toast',
  templateUrl: './warning-toast.component.html',
  styleUrls: ['./warning-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningToastComponent implements ToastBaseComponent {
  public data: ToastData = inject(MAT_SNACK_BAR_DATA);

  constructor(public snackBarRef: MatSnackBarRef<WarningToastComponent>) {}
}
